// @flow

export function getStudioEditorUrl(pageId: string): string {
  return `/admin/studio/sso/${encodeURIComponent(pageId)}`;
}

export function getStudioEditorPreviewUrl(
  pageId: string,
  viewport: 'desktop' | 'mobile' | 'responsive' = 'responsive'
): string {
  const editorUrl = getStudioEditorUrl(pageId);
  return `${editorUrl}?preview=${encodeURIComponent(viewport)}`;
}

